import Map from "./Map";

class MapDetail extends Map {
  constructor(elem, locations) {
    super(elem, locations, 17);

    this.filterInputs = elem.querySelectorAll("input.js-map-filter");
    this.filters = [];

    this.radius = "500";

    this.infoWindow = new window.google.maps.InfoWindow();

    this._setDOMReferences();
  }

  _setDOMReferences() {
    for (let i = 0; i < this.filterInputs.length; i++) {
      const element = this.filterInputs[i];
      element.addEventListener("change", () =>
        this.onFilterChange(element)
      );
    }
  }

  onFilterChange(element) {
    const filterVal = element.value;

    if (element.checked) {
      this.filters.push(filterVal);
    } else {
      this.filters = this.filters.filter(item => item != filterVal);
    }

    if (this.markers.hasOwnProperty(filterVal)) {
      element.checked
        ? this.toggleMarkerGroup("show", filterVal)
        : this.toggleMarkerGroup("hide", filterVal);
    } else {
      this.markers[filterVal] = [];
      this.getFilterMarkers(filterVal);
    }
  }

  toggleMarkerGroup(toggleType, filterType) {
    const map = toggleType == "show" ? this.map : null;
    for (let i = 0; i < this.markers[filterType].length; i++) {
      const marker = this.markers[filterType][i];
      marker.setMap(map);
    }

    if (map === null) {
      this.removeMarkersFromCluster(this.markers[filterType]);
    } else {
      this.addMarkersToCluster(this.markers[filterType]);
    }
  }

  getFilterMarkers(type) {
    const request = {
      location: this.locations[0],
      radius: this.radius,
      type: [type]
    };

    const service = new window.google.maps.places.PlacesService(this.map);
    service.nearbySearch(request, callback);

    const self = this;

    function callback(results, status) {
      if (!results.length && status === "ZERO_RESULTS") {
        console.log(type, "Geen resultaten");
      }

      if (status == google.maps.places.PlacesServiceStatus.OK) {
        for (var i = 0; i < results.length; i++) {
          self.createPoiMarker(results[i], type);
        }

        self.addMarkersToCluster(self.markers[type]);

        self.map.fitBounds(self.bounds);
        self.map.panToBounds(self.bounds);
      }
    }
  }

  createPoiMarker(place, type) {
    const marker = new window.google.maps.Marker({
      map: this.map,
      position: place.geometry.location
    });

    this.markers[type].push(marker);

    const self = this;

    window.google.maps.event.addListener(marker, "click", function () {
      const contentString =
        '<div class="infowindow__inner">' +
        '<div class="infowindow__title">' +
        place.name +
        "</div>" +
        '<div class="infowindow__address">' +
        place.vicinity +
        "</div>" +
        "</div>";

      self.infoWindow.setContent(contentString);
      self.infoWindow.open(this.map, this);
    });

    this.bounds.extend(place.geometry.location);
  }
}

export default MapDetail;
